import { FC } from 'react';
// components
import SweetenerComponent from 'components/main/SweetenerSystem/Edit';

const EditSweetener: FC = () => <SweetenerComponent />;

export default EditSweetener;
